import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import LogRocket from "logrocket";
import { UserMenuService } from "./services/usermenu.service";
import { RandomSessionIdService } from "../../guards/random-session-id.service";
import { LayoutService } from "../../layout/service/app.layout.service";
import { LoginServices } from "./services/login.service";
import { MessageService } from "primeng/api";
import { TramitePagosService } from "../../users/pagos/services/tramite-pagos.service";
import { TokenInterface } from "./interfaces/login.interface";
import Swal from "sweetalert2";
import {environment} from "../../../environments/environment.development";

const apiVucUrl = environment.apiVucUrl;

@Component({
    selector: 'app-token-receiver',
    standalone: true,
    providers: [MessageService],
    template: ''
})

export class CallbackComponent implements OnInit {
    loading: boolean = false;
    sessionId: string | null;
    mensaje: string = '';

    constructor(
        private userMenuService: UserMenuService,
        public rs: RandomSessionIdService,
        private layoutService: LayoutService,
        public loginServices: LoginServices,
        private route: ActivatedRoute,
        private router: Router,
        private messageService: MessageService,
        private tramitePagosService: TramitePagosService,
        private http: HttpClient
    ) {
        this.sessionId = rs.randomSessionId();
        this.resetGlobalStates();
        this.mensaje = 'No se pudo iniciar sesión desde Identidad Digital';
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            const code = params['code'];

            if (!code) {
                this.showErrorAndRedirect('Código de autorización no proporcionado');
                return;
            }

            this.showLoadingAlert();
            this.handleAuthorizationCode(code);
        });
    }

    private handleAuthorizationCode(code: string): void {
        this.loading = true;

        this.http.get<any>(apiVucUrl+`api/v1.0/callback?code=${code}`).subscribe({
            next: (response) => {
                // callback
                if (response.token) {
                    const tokenData = response as TokenInterface;
                    this.createSessionID(tokenData);
                } else if (response.error) {
                    this.showErrorAndRedirect(response.error.mensaje || this.mensaje);
                } else {
                    this.showErrorAndRedirect(this.mensaje);
                }
            },
            error: (error) => {
                this.loading = false;
                console.error('Error en la petición al backend:', error);
                this.showErrorAndRedirect(error.error?.mensaje || this.mensaje);
            }
        });
    }

    private showLoadingAlert(): void {
        Swal.fire({
            title: 'Procesando autorización',
            html: 'Por favor espere...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    }

    private showErrorAndRedirect(message: string): void {
        Swal.fire({
            icon: "warning",
            title: `Atención`,
            text: message,
            showCancelButton: false,
            confirmButtonText: "Ok",
            confirmButtonColor: "#28a745",
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.router.navigate(['']);
            }
        });
    }

    private createSessionID(token: TokenInterface) {
        this.resetGlobalStates();
        this.loginServices.session.set(token);

        if (!token.perfil || !token.perfil.usuario) {
            this.showErrorAndRedirect('No se pudo iniciar sesión desde Identidad Digital');
            return;
        }

        LogRocket.identify(token.perfil.uniqueId!, {
            name: token.perfil.usuario!
        });

        LogRocket.track("login_success");
        this.userMenuService.getMenusPorRol(this.userMenuService.getUniqueIDs(token.perfil.roles));
        Swal.close();
        this.router.navigate([this.loginServices.getDefaultRoute(token.perfil)]);
    }

    private resetGlobalStates() {
        this.loginServices.removerSession();
        this.userMenuService.rutas.set([]);
        this.tramitePagosService.resetState();
        sessionStorage.clear();
        localStorage.clear();
    }
}
